/*
 * Validate-discounts.ts
 * Description: Includes the declaration
 * of the functions for validating a discounts
 */

// Importing variables
import {
    InvalidDiscount, InvalidMinOrder, InvalidTotalCoupon,
    MissingDiscount, MissingExpiration, MissingMinOrder,
    MissingTotalCoupon,
} from '@/ts/variables';

export interface Coupon {
    total_coupons: number;
    discount: number;
    min_order: number;
    expiration: string;
}

/**
 * Validating discount data before updating
 *
 * @param {String[]} errors - a list of errors
 * @param {Coupon} data - discount data
 */
export function validateCoupons(errors: string[], data: Coupon) {
    // Validating total coupons
    if (data.total_coupons === 0) { errors.push(MissingTotalCoupon); }
    if (data.total_coupons < 1 && data.total_coupons > 40) { errors.push(InvalidTotalCoupon); }

    // Validating discount
    if (data.discount === 0) { errors.push(MissingDiscount); }
    if (data.discount < 1 && data.discount > 100) { errors.push(InvalidDiscount); }

    // Validating min order
    if (data.min_order === 0) { errors.push(MissingMinOrder); }
    if (data.min_order < 1) { errors.push(InvalidMinOrder); }

    // Validating expiration
    if (data.expiration.length === 0) { errors.push(MissingExpiration); }
}
